import "../styles/quiz.css";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchQuizDetailsAction,
  solveQuizAction,
  deleteQuiz,
} from "../redux/slices/quizSlices";
import { useFormik } from "formik";

import { changePrevLinkAction } from "../redux/slices/userSlices";
import UserNav from "./UserNav";

function QuizPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userStoreData = useSelector((store) => store?.users);
  const { user } = userStoreData;

  if (!user) {
    const data = {
      prevLink: "/Questions",
    };
    dispatch(changePrevLinkAction(data));
    navigate("/login");
  }

  useEffect(() => {
    dispatch(fetchQuizDetailsAction());
  }, [dispatch]);

  const quizStoreData = useSelector((store) => store?.quiz);
  const { pastQuiz, presentQuiz, solved } = quizStoreData;

  const formik = useFormik({
    initialValues: {
      userAnswer: "",
    },

    onSubmit: (values) => {
      if (values.userAnswer.length > 0) {
        const data = {
          questionId: presentQuiz.id,
          answer: values.userAnswer,
        };

        // console.log(data);

        dispatch(solveQuizAction(data));
      }
    },

    // validationSchema : quizFormSchema,
  });

  const deleteQuestion = (id) => {
    const data = {
      quizId: id,
    };
    dispatch(deleteQuiz(data));
    navigate("/Questions");
  };

  const dateFormator = (d) => {
    const date = new Date(d);
    const time = date.toLocaleDateString("en-Us", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    return time;
  };

  const setAnswer = (answer) => {
    formik.values.userAnswer = answer;
  };

  const PastQuestion = ({ date, question, answer, attempts, id }) => (
    <div className="past-question-container">
      <div className="past-question">
        <div className="past-question-header">
          <span className="data">{dateFormator(date)}</span>
          {user?.role === "admin" ? (
            <button className="delete-btn" onClick={() => deleteQuestion(id)}>
              Delete
            </button>
          ) : null}
        </div>
        <div id="qtn" dangerouslySetInnerHTML={{ __html: question }} />
        <div id="ans">Answer: {answer}</div>
        {attempts ? <div id="attempts">Attempts: {attempts.length}</div> : null}
      </div>
    </div>
  );

  const QuestionBox = () => {
    return (
      <div className="qtn_container">
        {presentQuiz ? (
          <div>
            <h1 id="today_task">Today's task</h1>
            <form onSubmit={formik.handleSubmit}>
              <div className="today_qtn">
                <h2
                  id="qtn"
                  dangerouslySetInnerHTML={{ __html: presentQuiz?.question }}
                />
                <ul id="optns_box">
                  <li id="optns">
                    <input
                      type="radio"
                      name="userAnswer"
                      value={presentQuiz?.Options[0]}
                      onClick={() => {
                        setAnswer(presentQuiz?.Options[0]);
                      }}
                    />{" "}
                    {presentQuiz?.Options[0]}
                  </li>
                  <li id="optns">
                    <input
                      type="radio"
                      name="userAnswer"
                      value={presentQuiz?.Options[1]}
                      onClick={() => {
                        setAnswer(presentQuiz?.Options[1]);
                      }}
                    />{" "}
                    {presentQuiz?.Options[1]}
                  </li>
                  <li id="optns">
                    <input
                      type="radio"
                      name="userAnswer"
                      value={presentQuiz?.Options[2]}
                      onClick={() => {
                        setAnswer(presentQuiz?.Options[2]);
                      }}
                    />{" "}
                    {presentQuiz?.Options[2]}
                  </li>
                  <li id="optns">
                    <input
                      type="radio"
                      name="userAnswer"
                      value={presentQuiz?.Options[3]}
                      onClick={() => {
                        setAnswer(presentQuiz?.Options[3]);
                      }}
                    />{" "}
                    {presentQuiz?.Options[3]}
                  </li>
                </ul>
              </div>
              {solved ? (
                <input type="button" className="solve-btn" value="Submitted" />
              ) : (
                <button type="submit" className="solve-btn">
                  Submit
                </button>
              )}
            </form>
          </div>
        ) : null}

        <h1 id="today_task">Past Questions</h1>
        <div>
          {pastQuiz ? (
            <div>
              {pastQuiz?.map((ques, index) => (
                <PastQuestion
                  date={ques?.createdAt}
                  question={ques?.question}
                  answer={ques?.answer}
                  attempts={ques?.solvedMembers}
                  id={ques?.id}
                />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <>
      <UserNav />
      <div className="question_page">
        <QuestionBox />
      </div>
    </>
  );
}

export default QuizPage;
